import store from "@/store/store";
import FirebaseRead from "@/services/database/firebaseRead";
import SPIELER_MEMBERSHIP_HANDLER from "@/services/data/spieler/spielerMembershipHandler";
import {SpielerRollenService} from "@/services/data/spieler/spielerRollen";
import PRINT_PAESSE_UPDATE_SPIELER from "@/services/print/printPaesseUpdateSpieler";
import TimeStamp from "@/services/timeStamp";
import {SPIELER_ACTION_SETTINGS} from "@/services/data/spielerActionIcons/spielerActionSettings";
import EXCEL_DOWNLOAD from "@/utilities/services/downloads/excel/excelDownload";

export class PrintPaesseService {
    constructor(showHistory) {
        this.filter = {
            pendingOnly: true,
            tsFrom: 0,
            tsUntil: 0,
        }
        this.passList = []
        this.druckListe = []
        this.filteredItems = []
        this.spielerActions = []
        this.preparingPrint = false;
        this.history = {
            show: showHistory,
            fromDate: '',
            untilDate: '',
            fromTs: 0,
            untilTs: 0,
            error: '',
        }
        this.search = null;
        this.setPendingPassList(true);
    }

    getMembershipOrLeihe(memberships){
        const currentLeihe = SPIELER_MEMBERSHIP_HANDLER.getCurrentLeihe(memberships)
        return currentLeihe ? currentLeihe : SPIELER_MEMBERSHIP_HANDLER.getLastRegularMembership(memberships)
    }

    setHistoryDates(init){
        this.history.error = ''
        if ( !this.history.show && !init ) return
        if ( init ) {
            const today = TimeStamp.getTodayString()
            this.history.untilTs = TimeStamp.getTimestampForDate( 'until', today)
            this.history.untilDate = today
            this.history.fromTs = this.history.untilTs - 7*24*60*60*1000
            this.history.fromDate = TimeStamp.getDateForTimestamp('', this.history.fromTs)
        } else {
            this.history.fromTs = TimeStamp.getTimestampForDate( '', this.history.fromDate)
            this.history.untilTs = TimeStamp.getTimestampForDate( 'until', this.history.untilDate)
        }
        if ( this.history.fromTs > this.history.untilTs ) this.history.error = "Das 'von'-Datum muss kleiner sein als das 'bis'-Datum!"
        if ( this.history.untilTs - this.history.fromTs > 30*24*60*60*1000 ) this.history.error = "Die Zeitspanne darf maximal 30 Tage betragen!"
    }

    async setPendingPassList(init){
        this.passList = []
        this.setHistoryDates(init)
        if ( this.history.error ) return
        let passList = []
        if ( !this.history.show ) {
            passList = await FirebaseRead.readDocList('spieler', {
                field: 'waitingForPassPrint', operator: '==', value: true
            })
        } else {
            passList = await FirebaseRead.readDocListDouble('spieler', [{
                field: 'tsLastPassPrint', operator: '>=', value: this.history.fromTs
            }, {
                field: 'tsLastPassPrint', operator: '<=', value: this.history.untilTs
            }])
        }
        passList = await this.addNationalitaetToPassList(passList)
        if ( !this.history.show ) {
            this.spielerActions = await FirebaseRead.readDocList('spieler_actions', {
                field: 'createdAt', operator: '>=', value: TimeStamp.getGMTTimestamp() - 31*24*60*60*1000
            })
            console.log ("SPIELER ACTIONS FOR PASS PRINT", this.spielerActions);
        }
        this.passList = passList.map(pass=>({
            passNr: this.getMembershipOrLeihe(pass.memberships).passNr,
            nachname: pass.nachname,
            vorname: pass.vorname,
            nationalitaet: pass.nationalitaet,
            typ: pass.tsLastPlayerPassPrint === 0 ? 'neu' : this.getActionIconList(pass),
            passList: this.getPassPrintListHeader(pass),
            info: null,
            spielerObjekt: pass,
            id: pass.id,
            letzteAenderung: pass.letzteAenderung
        })).sort((a, b) => a.letzteAenderung < b.letzteAenderung ? 1 : -1);
        this.bindLV()
    }
        async addNationalitaetToPassList(passList){
            const promiseList = []
            passList.forEach( (spieler) => {
                const pr = FirebaseRead.readSingleDoc('spieler/' + spieler.id + '/private', spieler.id)
                promiseList.push(pr)
            });
            const privateDocs = await Promise.all(promiseList)
            passList.forEach( (pass) => {
                const privDoc = privateDocs.find(priv => priv.id === pass.id)
                pass.nationalitaet = privDoc ? privDoc.nationalitaet : '-'
            });
            return passList
        }
        getActionIconList(pass){
            if ( !this.spielerActions ) return ''
            const spielerActions = this.spielerActions.filter(action => action.search_spieler === pass.id);
            let actionTypeList = []
            if ( spielerActions.length === 0 ) return 'geändert'
            spielerActions.forEach( (action) => {
                if ( actionTypeList.indexOf(action.actionType) === -1 &&
                    SPIELER_ACTION_SETTINGS[action.actionType].toolTipPass) actionTypeList.push(action.actionType)
            });
            if ( actionTypeList.length === 0 ) return 'geändert'
            let actionIconList = []
            actionTypeList.forEach( (actionType) => {
                actionIconList.push( SPIELER_ACTION_SETTINGS[actionType])
            });
            return actionIconList
        }
        bindLV(){ // needed for vereinsname
            const neededLvIds = {}
            this.passList.forEach( (item) => {
                neededLvIds[item.passNr.substr(0,2)] = true
            });
            Object.keys(neededLvIds).forEach( (lvId) => {
                if ( !store.state.realtime.landesverbaende[lvId] ) {
                    store.dispatch('bindRealtimeDocument', {
                        collection: 'landesverbaende',
                        docId: lvId,
                        storeField: 'landesverbaende.' + lvId,
                    });
                }
            });
        }

    setSelected(value){
        this.passList.forEach( (item) => {
            item.passList.forEach( (item) => {
                item.selected = value
            });
        });
    }

    getPassPrintListHeader(pass){
        let list = []
        if ( (!this.history.show && pass.waitingForPlayerPassPrint) ||
             (this.history.show &&
              pass.tsLastPlayerPassPrint >= this.history.fromTs &&
              pass.tsLastPlayerPassPrint <= this.history.untilTs)  ) {
            const label = this.getChipLabel(pass)
            list.push({type: 'sp', label: label, selected: false})
        }
        list = this.checkForOtherPendingPasses(pass, list)
        return list
    }
        getChipLabel(pass){
            return !this.history.show ? 'Spielerpass' :
                'Spielerpass' + ' / ' + TimeStamp.getLocalDateAndTime(pass.tsLastPlayerPassPrint)
        }
        checkForOtherPendingPasses(pass, list){
            const spielerRollenService = new SpielerRollenService(pass.roles);
            list = spielerRollenService.addPendingPassPrintsToList(list, this.history)
            return list
        }

    async createDruckListe(){
        this.preparingPrint = true;
        let atLeastOnePassSelected = this.passList.filter(
            pass => this.atLeastOneSelected(pass.passList))
    // get all private documents
        const privateDocsPromiseList = this.getPrivateDocsPromiseList(atLeastOnePassSelected)
        const privateDocs = await Promise.all(privateDocsPromiseList)
        atLeastOnePassSelected = this.addPrivateDocs(atLeastOnePassSelected, privateDocs)
        const druckListe = []
        for ( let i = 0; i < atLeastOnePassSelected.length; i++ ) {
            const pass = atLeastOnePassSelected[i]
            const url = await this.getLocalImage( pass.spielerObjekt.url, pass.spielerObjekt.id);
            for ( let j = 0; j < pass.passList.length; j++ ) {
                const passListItem = pass.passList[j]
                if ( passListItem.selected ) {
                    const passDoc = await this.getPassDruckObject(pass, passListItem, url)
                    druckListe.push(passDoc)
                }
            }
        }
        this.druckListe = druckListe;
        this.preparingPrint = false;
    }
        atLeastOneSelected(passList){
            for ( var i = 0; i < passList.length; i++ ) {
                if ( passList[i].selected ) return true
            }
            return false
        }

        getPrivateDocsPromiseList(atLeastOnePassSelected){
            const promiseList = []
            atLeastOnePassSelected.forEach( (item) => {
                promiseList.push(FirebaseRead.readSingleDoc(
                    'spieler/' + item.spielerObjekt.id + '/private', item.spielerObjekt.id ))
            });
            return promiseList
        }

        addPrivateDocs(atLeastOnePassSelected, privateDocs){
            let i = 0
            atLeastOnePassSelected.forEach( (item) => {
                item.privateData = privateDocs[i]
                i++
            });
            return atLeastOnePassSelected;
        }

        async getPassDruckObject(pass, passListItem, url){
            return {
                nrLabel: this.getNrLabel(pass, passListItem),
                nr: this.getNr(pass, passListItem),
                vorname: pass.vorname,
                nachname: pass.nachname,
                geburtsdatum: this.getFormatedDate(pass.privateData.geburtsdatum),
                ablaufdatum: this.getAblaufDatum(pass, passListItem),
                qrCode: pass.spielerObjekt.id + '_' + passListItem.type,
                id: pass.spielerObjekt.id,
                nationalitaet: pass.privateData.nationalitaet,
                url: url,
                landesVerband: this.getLandesVerband(pass, passListItem),//'LV Oberösterreich - Kegeln',
                flagBottomRow: this.getFlagBottomRow(pass, passListItem), // Verein oder Ausweisname
                type: passListItem.type,
                duplikat: pass.spielerObjekt.printIsDuplikat,
            }
        }
            async getLocalImage(url, spielerId){
                const fullUrl = store.state.config.storage.passfotos + spielerId + '.jpeg?' + url
                try {
                    const blob = await fetch(fullUrl).then(r => r.blob());
                    return blob.type !== 'application/json' ? URL.createObjectURL(blob) : ''
                } catch (e) {
                    return ''
                }
            }
            getNrLabel(pass, passListItem){
                if ( passListItem.type === 'sp' ) {
                    const membership = this.getMembershipOrLeihe(pass.spielerObjekt.memberships)
                    return membership.leihe ? 'Leihspielerpass' : 'Spielerpass';
                } else {
                    const spielerRollenService = new SpielerRollenService({});
                    return spielerRollenService.getNrLabel(passListItem.type)
                }
            }
            getNr(pass, passListItem){
                return passListItem.type === 'sp' ? pass.passNr : pass.spielerObjekt.roles[passListItem.type].nr
            }
            getAblaufDatum(pass, passListItem){
                let ablaufDatum = null
                if ( passListItem.type === 'sp' ) {
                    const currentLeihe = SPIELER_MEMBERSHIP_HANDLER.getCurrentLeihe(pass.spielerObjekt.memberships)
                    ablaufDatum = currentLeihe ? currentLeihe.until : SPIELER_MEMBERSHIP_HANDLER.getLastSportTagFromMemberships(pass.spielerObjekt.memberships)
                } else {
                    ablaufDatum = pass.spielerObjekt.roles[passListItem.type].bis
                }
                return ablaufDatum ? this.getFormatedDate(ablaufDatum) : '-'
            }
            getLandesVerband(pass, passListItem){
                const lvId = passListItem.type === 'sp' ? pass.passNr.substr(0,2) :
                                                          pass.spielerObjekt.roles[passListItem.type].lvId
                if ( passListItem.type === 'tr' ||
                     passListItem.type === 'uel' ||
                     passListItem.type === 'instr' ) {
                    return pass.spielerObjekt.sportart === 'classic' ? 'Sportkegeln - Classic' : 'Bowling'
                } else {
                    return store.state.local.landesverbaende.find(lv => lv.id === lvId)?.name??'';
                }
            }
            getFormatedDate(dateString){
                return TimeStamp.getStringDotDateFromString(dateString)
            }
            getFlagBottomRow(pass, passListItem){
                if ( passListItem.type === 'sp' ) {
                    const membership = this.getMembershipOrLeihe(pass.spielerObjekt.memberships)
                    const lvId = membership.lvVereinId.substring(0,2)
                    const vereinsId = membership.lvVereinId.substring(2)
                    return store.state.realtime.landesverbaende[lvId].vereine[vereinsId].name
                } else {
                    const spielerRollenService = new SpielerRollenService({});
                    return spielerRollenService.getFullRoleName(passListItem.type)
                }
            }

    removeCardFromDruckListe(clickedPass){
        const passFromList = this.passList.find(pass => pass.spielerObjekt.id === clickedPass.id)
        const selectedItem = passFromList.passList.find(passListItem => passListItem.type === clickedPass.type)
        selectedItem.selected = false;
        const index = this.druckListe.findIndex(item => item.id === clickedPass.id)
        this.druckListe.splice(index, 1)
    }

    async processPrint(){
        const promiseList = PRINT_PAESSE_UPDATE_SPIELER.getPromiseList(this.passList)
        await Promise.all(promiseList)
        this.druckListe = []
        this.setPendingPassList();
    }

    exportToExcel(){
        if ( this.passList.length === 0 ) return
        let items = JSON.parse(JSON.stringify(this.passList)).filter(item =>
            this.filteredItems.findIndex(filteredItem => filteredItem.id === item.id) !== -1 ||
            !this.search
        )
        items = items.map((item) => ({
            passNr: item.passNr, vorname: item.vorname, nachname: item.nachname,
            paesse: item.passList.map((pass) => (pass.label)).join(', ')
        }))
        EXCEL_DOWNLOAD.exportJsonToSingleSheet(
            items,
            'Paesse',
            TimeStamp.getTodayString(),
            [
                {text:'Nachname', value:'nachname'},
                {text:'Vorname', value:'vorname'},
                {text:'Pass-Nr.', value:'passNr'},
                {text:'Pässe', value:'paesse'},],
        );
    }

}